import { Dispatch, SetStateAction } from 'react';
import { useForm, FormProvider } from 'react-hook-form';
import { CompanyDto } from 'tdc-web-backend/companies/schemas';
import { Box } from '@mui/material';
import { EnumService, mapService } from 'tdc-web-backend/enums/enums';
import { useTranslation } from 'react-i18next';
import { ReactComponent as SuitcaseCheckIcon } from '../../../../../../../../../../assets/icons/layout-icons/SuitcaseCheckIcon.svg';
import ConfirmModal from '../../../../../../../../../../components/confirm-modal/ConfirmModal';
import { primaryLight } from '../../../../../../../../../../utils/color';
import CustomInput from '../../../../../../../../../../components/custom-input/CustomInput';
import { useRefresh } from '../../../../../../../../../../utils/hooks/crud-hooks/useRefresh';
import useUserCompany from '../../../../../../../../../../utils/hooks/useUserCompany';

interface CompanyTechLanguagesEditModalProps {
  isEditModalOpen: boolean;
  setIsEditModalOpen: Dispatch<SetStateAction<boolean>>;
}

const CompanyServicesEditModal = ({
  isEditModalOpen,
  setIsEditModalOpen,
}: CompanyTechLanguagesEditModalProps) => {
  const { company: companyData, updateCompany, isLoadingUpdateCompany } = useUserCompany();
  const refresh = useRefresh();

  const formMethods = useForm<Pick<CompanyDto, 'services'>>({
    defaultValues: {
      services: companyData?.services ?? ([] as EnumService[]),
    },
    mode: 'onChange',
  });
  const { t } = useTranslation();
  const { handleSubmit, getValues } = formMethods;

  const onSubmit = () => {
    updateCompany(
      { services: getValues('services') },
      {
        onSuccess: () => {
          refresh();
          setIsEditModalOpen(false);
        },
      },
    );
  };

  return (
    <ConfirmModal
      width="40%"
      isModalOpen={isEditModalOpen}
      setIsModalOpen={setIsEditModalOpen}
      title={t('settings.companyProfile.services')}
      onCancel={() => setIsEditModalOpen(false)}
      automaticallyCloseModalOnButtonClick={false}
      isLoading={isLoadingUpdateCompany}
      onConfirm={handleSubmit(onSubmit)}
      confirmButtonText={t('common.save')}
      message={
        <FormProvider {...formMethods}>
          <Box component="form">
            <CustomInput
              required
              input={<CustomInput.Autocomplete />}
              choices={mapService}
              translation={{ ns: 'enum' }}
              name="services"
              label={t('settings.companyProfile.services')}
              multiple
              placeholder={t('common.select')}
              sx={{ width: '100%' }}
            />
          </Box>
        </FormProvider>
      }
      iconProps={{
        icon: <SuitcaseCheckIcon fill={primaryLight[500]} />,
        wrapperBackgroundColor: primaryLight[100],
      }}
    />
  );
};

export default CompanyServicesEditModal;
